if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('.product-form__buttons > [name="add"]') || this.querySelector('[name="add"]');
        if (!this.form || !this.submitButton) return;
        this.submitButtonText = this.submitButton.querySelector('span') || this.submitButton;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.submitButtonText.textContent.trim() !== 'SOLD OUT') {
          this.checkIfProductInCart();
        }

        document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
      }

      // Method to check if the product is already in the cart
      checkIfProductInCart() {
        const variantId = this.variantIdInput.value;

        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const itemInCart = cart.items.some((item) => item.variant_id == variantId);
            this.updateButtonState(itemInCart);
          })
          .catch((error) => {
            console.error('Error fetching cart contents:', error);
          });
      }

      updateButtonState(isInCart) {
        if (isInCart === true) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.disabled = true;
          this.submitButtonText.textContent = 'IN CART';
          this.submitButton.classList.add('button-disabled');
        } else if (this.submitButtonText.textContent.trim() !== 'SOLD OUT') {
          // Only update to 'Cart' if it wasn't previously disabled by Liquid as "SOLD OUT"
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.disabled = false;
          this.submitButtonText.textContent = 'ADD TO CART';
          this.submitButton.classList.remove('button-disabled');
        }
      }

      onCartUpdated() {
        // Re-check the cart contents and update the button accordingly
        if (this.submitButtonText.textContent.trim() !== 'SOLD OUT') {
          this.checkIfProductInCart();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const sxSpin = this.querySelector('.loading__spinner'); if (sxSpin) sxSpin.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            { const s = this.querySelector('.loading__spinner'); if (s) s.classList.add('hidden'); }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = 'ADD TO CART';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
